module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"sunrise":"Восход","sunset":"Закат","daylight":"Световой день","day1":"Воскресенье","day2":"Понедельник","day3":"Вторник","day4":"Среда","day5":"Четверг","day6":"Пятница","day7":"Суббота"}}')
  delete Component.options._Ctor
}
